export const FORM_ITEMS_TYPE = {
  text: 'text',
  select: 'select',
  date: 'date',
  boolean: 'boolean',
  customSkillsComponent: 'customSkillsComponent',
  withSwitcher: 'withSwitcher',
  checkbox: 'checkbox',
  miniJobDocument: 'miniJobDocument',
  signature: 'signature',
  country: 'country',
  autocomplete: 'autocomplete',
  personalIdCard: 'personalIdCard',
  healthInsuranceCard: 'healthInsuranceCard'
};

export const QUESTIONNAIRE_FORM_STEPS = {
  employeePersonalInfo: 'employeePersonalInfo',
  paymentAndInsurance: 'paymentAndInsurance',
  educationAndSkills: 'educationAndSkills',
  emergencyContact: 'emergencyContact',
  finishInformation: 'finishInformation',
};
